import React, { useContext } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Box, ButtonBase, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import useDialogState from "@/hooks/useDialogState";
import useGlobalSnackbar from "@/hooks/useGlobalSnackbar";

import PlannedMealFormDialog from "./Dialogs/PlannedMealFormDialog";
import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()((theme) => ({
  root: {
    position: "relative",
  },
  button: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: "100%",
    padding: theme.spacing(4, 2),
  },
  addIcon: {
    position: "absolute",
    border: `2px solid ${theme.palette.primary.main}`,
    background: theme.palette.common.white,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 24,
    widht: 24,
    borderRadius: 50,
    bottom: "-12px",
    left: "50%",
    transform: "translate(-50%, 0)",
    zIndex: 10,
  },
}));

const AddPlannedMealButton: React.FC = observer(() => {
  const { classes } = useStyles();
  const snackbar = useGlobalSnackbar();
  const plannedMealFormDialog = useDialogState();

  const store = useContext(MealPlanFormStore.Context);

  return (
    <>
      <ButtonBase className={classes.root} onClick={plannedMealFormDialog.show}>
        <Box className={classes.button}>
          <Typography variant="caption">Add custom meal</Typography>
        </Box>
        <div className={classes.addIcon}>
          <AddIcon fontSize="small" />
        </div>
      </ButtonBase>
      <PlannedMealFormDialog
        open={plannedMealFormDialog.shown}
        onClose={plannedMealFormDialog.hide}
        onSubmit={(values) => {
          const plannedMeal = store.plannedMealRows.add(
            values.meal,
            values.recommendedTime
          );
          snackbar.open(`${plannedMeal.label} added successfully`);
        }}
      />
    </>
  );
});

export default AddPlannedMealButton;
